import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { Icon, Popover, Tooltip } from "antd";
import { validateComercialTuristik, getNewPermission } from "../../utils/index";
import classNames from "classnames/bind";
import {
  setSelectItem,
  setSelectExpandAsset,
  setSelectEditAsset,
  setSelectShareAsset
} from "../../actions/ClientAction";
import {
  isHoverActive,
  isntHoverActive
} from "../../actions/HoverVerticalAction";
import { individualSelectItem } from "../../actions/IndividualSelectAction";
import {
  showComment,
  iconCommentsPrivateNavbar,
  manageListComment,
  setQtyVersions
} from "../../actions/CommentAction";
// import BunkeyAssetsTour from "../tour/BunkeyAssetsTour";

function DartIcon(props) {
  return (
    <React.Fragment>
      <div className={props.isActive ? "active" : ""} onClick={props.onClick}>
        <svg
          width="28"
          height="25"
          viewBox="0 0 24 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.10738 11.844C7.72013 11.844 8.21686 11.3472 8.21686 10.7345C8.21686 10.1217 7.72013 9.625 7.10738 9.625C6.49464 9.625 5.99791 10.1217 5.99791 10.7345C5.99791 11.3472 6.49464 11.844 7.10738 11.844Z"
            fill="#FFFF"
          />
          <path
            d="M13.1446 10.7345C13.1446 11.3472 12.6479 11.844 12.0351 11.844C11.4224 11.844 10.9256 11.3472 10.9256 10.7345C10.9256 10.1217 11.4224 9.625 12.0351 9.625C12.6479 9.625 13.1446 10.1217 13.1446 10.7345Z"
            fill="#FFFF"
          />
          <path
            d="M16.9648 11.844C17.5776 11.844 18.0743 11.3472 18.0743 10.7345C18.0743 10.1217 17.5776 9.625 16.9648 9.625C16.3521 9.625 15.8553 10.1217 15.8553 10.7345C15.8553 11.3472 16.3521 11.844 16.9648 11.844Z"
            fill="#FFFF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.933287 19.7599L2.61989 16.3219C1.5386 14.6192 1.07603 13.1663 1.07603 11C1.07603 4.92487 6.0009 0 12.076 0C18.1512 0 23.076 4.92487 23.076 11C23.076 17.0751 18.1512 22 12.076 22C9.70265 22 7.89078 21.4598 6.09358 20.1815L1.48405 20.5667C1.04944 20.603 0.741205 20.1515 0.933287 19.7599ZM3.31775 18.7234L6.56751 18.4518L7.06974 18.809C8.55323 19.8642 10.0157 20.3158 12.076 20.3158C17.221 20.3158 21.3918 16.145 21.3918 11C21.3918 5.85503 17.221 1.68421 12.076 1.68421C6.93107 1.68421 2.76025 5.85503 2.76025 11C2.76025 12.8349 3.12541 13.9762 4.04163 15.419L4.54779 16.216L3.31775 18.7234Z"
            fill="#FFFF"
          />
        </svg>
      </div>
    </React.Fragment>
  );
}

export class CollectionItemHover extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active: false,
      hoverColor: "",
      hoverSpanColor: "",
      colorTransition: "",
      colorOpacity: "0.9",
      canEdit: true,
      canShare: true,
      canMove: true,
      mouseHover: false,
      canCommentsAndVersions: false
      // showAssetsTour: false
    };
  }

  componentDidMount() {
    const { active } = this.state;
    const {
      newColor,
      itemHover,
      keyCollection,
      user,
      newMatrix,
      modules
    } = this.props;

    if (active) {
      this.setState({
        hoverColor: newColor,
        hoverSpanColor: newColor,
        colorTransition: "all 0.3s"
      });
    } else if (newColor) {
      this.setState({
        hoverColor: newColor,
        hoverSpanColor: newColor,
        colorTransition: "all 0.3s"
      });
    } else {
      this.setState({
        hoverSpanColor: "rgba(46, 151, 207, 0.3)",
        hoverColor: "rgba(46, 151, 207, 0.8)",
        colorTransition: "all 0.3s"
      });
    }

    if (
      keyCollection === "assetsPublicShared" ||
      (user.clientRole !== "admin" && user.role !== "admin")
    ) {
      this.setState({
        canEdit: getNewPermission(itemHover._id, newMatrix, "edit"),
        canShare: getNewPermission(itemHover._id, newMatrix, "share"),
        canMove: getNewPermission(itemHover._id, newMatrix, "move")
      });
    }

    if (modules && keyCollection !== "assetsPublicShared") {
      modules.forEach(module => {
        if (module.name === "commentsAndVersions") {
          const canComment =
            user.clientRole === "admin" ||
            user.role === "admin" ||
            (module.activate &&
              (getNewPermission(
                itemHover._id,
                newMatrix,
                "createVersionDart"
              ) ||
                getNewPermission(
                  itemHover._id,
                  newMatrix,
                  "viewVersionsDart"
                ) ||
                getNewPermission(
                  itemHover._id,
                  newMatrix,
                  "createCommentDart"
                )));
          this.setState({
            canCommentsAndVersions: canComment
          });
        }
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { active } = this.state;
    const { newColor } = this.props;
    if (active && prevProps.newColor !== newColor) {
      this.setState({
        hoverColor: newColor
      });
    }
  }

  handleOnClick = e => {
    const { active } = this.state;
    this.setState({
      active: !active
      // showAssetsTour: true
    });
  };

  handleCollectionClick = () => {
    const { hoverDetail } = this.props;
    if (hoverDetail) {
      this.setState({
        active: true
      });
    }
  };

  handleOnMouseEnter = () => {
    const { mouseHover } = this.state;
    this.setState({
      mouseHover: true
    });
    this.props.isHoverActive(mouseHover);
  };

  handleOnMouseLeave = () => {
    const { mouseHover } = this.state;
    this.setState({
      mouseHover: false
    });
    this.props.isntHoverActive(mouseHover);
  };

  // Se usa el mismo DownloadModal que el resto de las descargas (click derecho,
  // buscador, explorar). En el ambiente externo lo renderiza Shared.js a partir
  // del individualSelect, asi el modal no depende del hover del asset.
  handleShowDownloadModal = e => {
    const { itemHover, keyCollection } = this.props;
    e.stopPropagation();
    this.props.individualSelectItem(itemHover, "download", keyCollection);
  };

  handleShowMessage = () => {
    const {
      itemHover,
      keyCollection,
      showComment,
      setQtyVersions,
      iconCommentsPrivateNavbar,
      manageListComment
    } = this.props;
    setQtyVersions("..");
    showComment(itemHover, keyCollection);
    iconCommentsPrivateNavbar(false);
    manageListComment(false);
  };

  render() {
    const { itemHover, keyCollection, intl } = this.props;

    const {
      active,
      hoverColor,
      colorTransition,
      hoverSpanColor,
      colorOpacity,
      canShare,
      canEdit,
      canMove,
      canCommentsAndVersions
      // showAssetsTour
    } = this.state;

    const classHoverDetail = classNames("hover-detail", { active: active });
    const classHoverSpan = classNames({ active: active });
    const classHoverMore = classNames("hover-more", { active: active });
    const classHoverClose = classNames("hover-close", { active: active });
    const tabEdit = "edit";
    const tabMove = "move";

    return (
      <div
        onMouseLeave={this.handleOnMouseLeave}
        onMouseEnter={this.handleOnMouseEnter}
        className={classHoverDetail}
        onClick={this.handleOnClick}
        style={{
          backgroundColor: hoverColor,
          transition: colorTransition,
          opacity: colorOpacity,
          color: "#ffffff"
        }}
      >
        <div className="hover-name">
          {itemHover.name.length > 25 ? (
            <Popover content={itemHover.name} placement="bottom">
              <span
                className={classHoverSpan}
                style={{
                  backgroundColor: hoverSpanColor,
                  transition: colorTransition,
                  overflow: "hidden",
                  color: "#ffffff"
                }}
              >{`${itemHover.name.slice(0, 24)}...`}</span>
            </Popover>
          ) : (
            <span
              className={classHoverSpan}
              style={{
                backgroundColor: hoverSpanColor,
                transition: colorTransition,
                overflow: "hidden",
                color: "#ffffff"
              }}
            >
              {itemHover.name}
            </span>
          )}
          <img
            alt="asset"
            src="/images/icons/dots-icon.svg"
            className={classHoverMore}
          />
          <img
            alt="asset"
            src="/images/icons/close-icon.svg"
            className={classHoverClose}
            onClick={this.handleOnClick}
          />
        </div>

        <ul>
          {keyCollection !== "assetsPublicShared" && (
            <React.Fragment>
              {/* ICONO DART */}
              {canCommentsAndVersions && (
                <li className="assets-tour-dart">
                  <Tooltip
                    placement="top"
                    title={intl.formatMessage({ id: "comments_title" })}
                  >
                    <span></span>
                    <DartIcon onClick={this.handleShowMessage} />
                  </Tooltip>
                </li>
              )}
              {/* ICONO EDITAR */}
              {canEdit && (
                <li>
                  <Tooltip title={intl.formatMessage({ id: "rename_asset" })}>
                    <img
                      alt="asset"
                      src="/images/icons/edit-icon.svg"
                      style={{ cursor: "pointer" }}
                      // Se envia parametro "tabEdit" para que el drawer abra en la pestaña correspondiente al icono
                      onClick={() =>
                        this.props.setSelectEditAsset(
                          keyCollection,
                          itemHover,
                          tabEdit
                        )
                      }
                    />
                  </Tooltip>
                </li>
              )}

              {/* ICONO COMPARTIR */}
              {canShare && validateComercialTuristik() && (
                <li>
                  <Tooltip
                    placement="top"
                    title={intl.formatMessage({ id: "shared_share" })}
                  >
                    <img
                      alt="asset"
                      src="/images/icons/share-icon.svg"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        this.props.setSelectShareAsset(keyCollection, itemHover)
                      }
                    />
                  </Tooltip>
                </li>
              )}

              {/* ICONO MOVER */}
              {canMove && (
                <li>
                  <Tooltip
                    placement="top"
                    title={intl.formatMessage({ id: "move_asset" })}
                  >
                    <Icon
                      style={{
                        color: "white",
                        fontSize: "25px",
                        cursor: "pointer"
                      }}
                      type="export"
                      // Se envia parametro "tabMove" para que el drawer abra en la pestaña correspondiente al icono
                      onClick={() =>
                        this.props.setSelectEditAsset(
                          keyCollection,
                          itemHover,
                          tabMove
                        )
                      }
                    />
                  </Tooltip>
                </li>
              )}
            </React.Fragment>
          )}
          {/* ICONO EXPANDIR */}
          {keyCollection === "assetsPublicShared" && (
            <ul>
              <li style={{ display: "flex", justifyContent: "center" }}>
                <Tooltip
                  placement="top"
                  title={intl.formatMessage({ id: "expand_asset" })}
                >
                  <img
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      this.props.setSelectExpandAsset(keyCollection, itemHover)
                    }
                    alt="asset"
                    src="/images/icons/expand-icon.svg"
                  />
                </Tooltip>
              </li>
              <li>
                <Tooltip
                  placement="top"
                  title={intl.formatMessage({ id: "download_asset" })}
                >
                  <Icon
                    style={{
                      color: "white",
                      fontSize: 25,
                      marginTop: -2,
                      cursor: "pointer"
                    }}
                    type="cloud-download"
                    onClick={this.handleShowDownloadModal}
                  />
                </Tooltip>
              </li>
            </ul>
          )}
        </ul>
        {/* {showAssetsTour && <BunkeyAssetsTour/>} */}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { keyCollection } = ownProps;
  let object;
  switch (keyCollection) {
    case "assetsRoot":
      object = {
        isFetching: state.assetsRoot.isFetching,
        data: state.assetsRoot.data,
        folderselect: state.assetsRoot.folderselect,
        error: state.assetsRoot.error,
        activeView: state.assetsRoot.activeView
      };
      break;
    case "assetsLastUploads":
      object = {
        isFetching: state.assetsLastUploads.isFetching,
        data: state.assetsLastUploads.data,
        folderselect: state.assetsLastUploads.folderselect,
        error: state.assetsLastUploads.error,
        activeView: state.assetsLastUploads.activeView
      };
      break;
    case "assetsShared":
      object = {
        isFetching: state.assetsShared.isFetching,
        data: state.assetsShared.data,
        folderselect: state.assetsShared.folderselect,
        error: state.assetsShared.error,
        activeView: state.assetsShared.activeView
      };
      break;
    case "assetsFavorites":
      object = {
        isFetching: state.assetsFavorites.isFetching,
        data: state.assetsFavorites.data,
        folderselect: state.assetsFavorites.folderselect,
        error: state.assetsFavorites.error,
        activeView: state.assetsFavorites.activeView
      };
      break;
    case "assetsExplore":
      object = {
        isFetching: state.assetsExplore.isFetching,
        data: state.assetsExplore.data,
        folderselect: state.assetsExplore.folderselect,
        error: state.assetsExplore.error,
        activeView: state.assetsExplore.activeView
      };
      break;
    case "assetsPublicShared":
      object = {
        isFetching: state.assetsPublicShared.isFetching,
        data: state.assetsPublicShared.data,
        folderselect: state.assetsPublicShared.folderselect,
        itemExpandSelected: state.assetsPublicShared.data.find(
          r => r.isExpandSelected
        ),
        error: state.assetsPublicShared.error,
        activeView: state.assetsPublicShared.activeView,
        webToken: state.assetsPublicShared.webToken
      };
      break;
    case "searcher":
      object = {
        activeView: state.assetsShared.activeView,
        folderselect: state.searcher.folderselect
      };
      break;

    default:
      object = {};
      break;
  }

  return {
    ...object,
    user: state.authUser.user,
    newColor:
      state.authUser.user && state.authUser.user.color
        ? state.authUser.user.color
        : "#2E97CF",
    newMatrix: state.group.newMatrix,
    modules: state.client.data ? state.client.data.modules : []
  };
};

const mapDispatchToProps = {
  setSelectItem,
  setSelectExpandAsset,
  setSelectEditAsset,
  setSelectShareAsset,
  isHoverActive,
  isntHoverActive,
  individualSelectItem,
  manageListComment,
  showComment,
  setQtyVersions,
  iconCommentsPrivateNavbar
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(CollectionItemHover))
);
